"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.csrfHandler = exports.setCSRFToken = exports.getCSRFToken = void 0;
var getCSRFToken = function () { var _a; return (_a = ocm === null || ocm === void 0 ? void 0 : ocm.config) === null || _a === void 0 ? void 0 : _a.CSRFToken; };
exports.getCSRFToken = getCSRFToken;
var setCSRFToken = function (token) {
    ocm.config.CSRFToken = token;
};
exports.setCSRFToken = setCSRFToken;
var csrfHandler = function (failedRequest) {
    var _a, _b;
    var token = (_a = failedRequest === null || failedRequest === void 0 ? void 0 : failedRequest.response) === null || _a === void 0 ? void 0 : _a.headers["csrftoken"];
    token && (0, exports.setCSRFToken)(token);
    if (((_b = failedRequest.response) === null || _b === void 0 ? void 0 : _b.config.headers) && token) {
        failedRequest.response.config.headers["CSRFToken"] = token;
    }
    return Promise.resolve();
};
exports.csrfHandler = csrfHandler;
